import { IBudgetAllocForm } from "../models/app-models"

export const missingGLFields = (budget: IBudgetAllocForm): boolean => {
    return ((budget.GLAcc?.value == null && budget.GLAcc?.id == null) ||
        (budget.GLAcc.value == '' && budget.GLAcc.id == ''))
}

export const missingCostCenterFields = (budget: IBudgetAllocForm): boolean => {
    return (budget.CostCentre?.value == null &&
        budget.CostCentre?.id == null) || (budget.CostCentre?.value == '' &&
            budget.CostCentre?.id == '')
}

export const missingBudgetFrequencyUsage = (budget: IBudgetAllocForm): boolean => {
    return (budget.BudgetFrequencyUsage?.value == null || budget.BudgetFrequencyUsage?.value == '') &&
        budget.BudgetExpenditureUsage?.value == 'Budgeted'
}

export const missingBudgetExpenditureUsage = (budget: IBudgetAllocForm): boolean => {
    return (budget.BudgetExpenditureUsage?.value == null || budget.BudgetExpenditureUsage?.value == '')
}

export const missingProjectCode = (budget: IBudgetAllocForm): boolean => {
    return (budget.ProjectCode?.value == null || budget.ProjectCode?.value == '')
}

export const missingProjectBudget = (budget: IBudgetAllocForm): boolean => {
    return (budget.ProjectBudget?.value == null || budget.ProjectBudget?.value == '')
}

export const missingFundCenter = (budget: IBudgetAllocForm): boolean => {
    return (budget.FundCentre?.value == null || budget.FundCentre?.value == '')
}

